<div class="row">

  <div class="col-md-11">
    <div mat-dialog-content  >

      <mat-form-field  class="search-full-width">

        <input cdkFocusInitial matInput [(ngModel)]="data.searchText"   placeholder="Digite as palavras para busca" (keydown.enter)="closeDialog()">
        <!--  -->

      </mat-form-field>
    </div>
  </div>
  <div class="col-md-1">
    <div mat-dialog-actions>
      <button mat-icon-button [mat-dialog-close]="data.searchText" >
        <mat-icon>youtube_searched_for</mat-icon>
      </button>

    </div>
  </div>

</div>